export enum TodoType {
  GROWELAB = 'growelab',
  ESUITE = 'esuite',
  EGROWE = 'egrowe',
}
